<template>
  <div class="how-it-works-step-card">
    <div class="how-it-works-step-card__badge-wrapper">
      <PTag>{{ number }}</PTag>
    </div>
    <SHeading class="how-it-works-step-card__title" level="3" size="3">
      {{ title }}
    </SHeading>
    <p class="how-it-works-step-card__description">{{ description }}</p>
  </div>
</template>

<script setup lang="ts">
import { PTag, SHeading } from "@solvari/components";

defineProps<{
  description: string;
  number: number;
  title: string;
}>();
</script>

<style lang="postcss">
.how-it-works-step-card {
  @apply flex flex-1 flex-col items-start overflow-hidden rounded-xl border border-primary-100 bg-white p-5 shadow-sm gap-3;

  &__badge-wrapper {
    @apply flex w-full justify-center;
  }

  &__title {
    @apply w-full text-center;
  }

  &__description {
    @apply text-center text-sm text-slate-700;
  }
}
</style>
